import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function uploadImage(formData, url) {

    const { data } = await apiClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // axios sets boundary automatically
      },
    });
  
    return data;
}

const socialIconCache = new Map();

async function getSocialNetworkIcon({ name })
{
// Check if the image is already cached
  if (socialIconCache.has(name)) {
    //console.log(`Returning cached image for name: ${name}`);
    return socialIconCache.get(name);
  }

  try {
    // Fetch the image from the API
    const { data, headers } = await apiClient({
      method: 'get',
      url: '/api/SocialNetwork/GetSocialNetworkIcon',
      params: { Name: name },
      responseType: 'arraybuffer',
    });

      // Extract content type from headers
    const contentType = headers['content-type'];

    // Create a Blob from the received data
    const blob = new Blob([data], { type: contentType });

    // Cache the image
    socialIconCache.set(name, blob);

    // Return the Blob or a URL for it (depending on usage)
    return blob;
  } catch (error) {
    console.error(`Error fetching icon for spcial network: ${name}`, error);
    throw error;
  }
}

const socialIconURLCache = new Map();

async function getSocialNetworkIconURL({name}) {
  // Check if the URL is already cached
  if (socialIconURLCache.has(name)) {
    //console.log(`Returning cached URL for name: ${name}`);
    return socialIconURLCache.get(name);
  }

  const icon = await getSocialNetworkIcon({ name });

  // Create a URL for the Blob
  const url = URL.createObjectURL(icon);
  socialIconURLCache.set(name, url);

  return url;
}

export {
   uploadImage,
   getSocialNetworkIconURL,
}